import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// 🔐 AUTH APIs
export const signup = (data) => API.post("/signup", data);
export const login = (data) => API.post("/login", data);

// 📁 Projects
export const getProjects = () => API.get("/projects");

export const createProject = (name) =>
  API.post("/projects", null, { params: { name } });

export const generateTestCases = (data) =>
  API.post("/generate", data);

export const getHistory = (projectId) =>
  API.get("/history", {
    params: { project_id: projectId },
  });

/*
export const uploadDocument = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return API.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};*/

export const uploadDocument = (file, projectId) => {
  const formData = new FormData();
  formData.append("file", file);

  return API.post(`/upload?project_id=${projectId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const downloadExcel = (test_cases) =>
  API.post(
    "/export-excel",
    { test_cases },
    { responseType: "blob" }   // 🔥 VERY IMPORTANT
  );

export const generateWithAgentV2 = (data) =>
  API.post("/agent-generate-v2", data);

export const getUsers = () => API.get("/admin/users");

export const activateUser = (user_id) =>
  API.post(`/admin/user/activate?user_id=${user_id}`);

export const deactivateUser = (user_id) =>
  API.post(`/admin/user/deactivate?user_id=${user_id}`);

export const changePlan = (user_id, plan) =>
  API.post(`/admin/user/plan?user_id=${user_id}&plan=${plan}`);

export default API;